/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { FilterBar } from "../../../components/molecule/molecule";
import { ModalAtom, AgGridAtom } from '../../../components/atoms/atom';
import { getRoleTableColumns } from './constant';
import AddRoleModal from './add/add-role';
import { getSearchAddFilter } from '../../../utils/get-filter-items';
import { searchData } from '../../../utils/search';
import { setting } from '../../../store/services/index';
import { showToast, getFormattedDate, showError } from '../../../utils/method';
import SettingsMenu from '../settings-menu/settings-menu';
import { AuthContext } from "../../../contexts/AuthProvider";

function RoleSettingPage() {
    const { t, i18n } = useTranslation();
    const { helpMode } = useContext(AuthContext);
    const [roleModalView, setRoleModalView] = useState('');
    const [selectedRole, setSelectedRole] = useState({});
    const [showDeleteModal, setShowdeleteModal] = useState(false);
    const filterItems = getSearchAddFilter(t, { addTextKey: 'add-role' });
    const [leftFilterItems, setLeftFilterItems] = useState(filterItems.left || []);
    const [roleList, setRoleList] = useState([]);
    const [filteredRoleList, setFilteredRoleList] = useState([]);

    const fetchRoles = async () => {
        try{
            let result = await setting.getRole();
            result = (result?.data || []).map((record) => {
                return {
                    ...record,
                    name: i18n.t(`ROLE_${record.name}`),
                    roleKey: record.name,
                    provided: getFormattedDate(record.createdAt)
                }
            })
            setRoleList(result);
            setFilteredRoleList(result);
        } catch(error){
            showError(t, error);
        }
    }
    
    useEffect(() => {
        fetchRoles();
    }, []);

    const onAddRole = async (roleInfo) => {
        try{
            if (roleModalView === 'add') {
                const res = await setting.addRole({
                    name: roleInfo.name
                });
                showToast(t(res?.message), { type: 'success' });
            } else if (roleModalView === 'edit') {
                const res = await setting.updateRole({
                    name: roleInfo.name
                }, roleInfo.id);
                showToast(t(res?.message), { type: 'success' });
            }  
            fetchRoles();
            setRoleModalView('');  
        } catch(error){
            showError(t, error);
        }
    }
    
    // eslint-disable-next-line no-unused-vars
    const onRoleEdit = (row, rowIndex) => {
        setSelectedRole(row);
        setRoleModalView('edit');
    };

    // eslint-disable-next-line no-unused-vars
    const onRoleDelete = (row, rowIndex) => {
        setSelectedRole(row);
        setShowdeleteModal(true);
    }
    
    const onDeleteRole = async () => {
        try {
            const res = await setting.deleteRole(selectedRole?.id);
            showToast(t(res?.message), { type: 'success' });
            fetchRoles();
            setShowdeleteModal(false);
        } catch(error) {
            showToast(t(error?.message), { type: 'error' });
        }
    }

    const roleColumns = getRoleTableColumns(t, helpMode);

    const onFilterAction = (index, key, info) => {
        if (key === 'search') {
            const localLeftFilterItems = [...leftFilterItems];
            localLeftFilterItems[0].value = info?.value;
            setLeftFilterItems(localLeftFilterItems);
            const filteredRoleList = searchData(info?.value, roleList, roleColumns);
            setFilteredRoleList(filteredRoleList);
        }
        if (key === 'add') {
            setSelectedRole({});
            setRoleModalView('add');
        }
    };

    return (
        <>
            <SettingsMenu />
            <FilterBar 
                leftItems={leftFilterItems}
                rightItems={[]}
                onFilterAction={onFilterAction} />
            
            <AgGridAtom 
                columnDefs={roleColumns}
                rowData={filteredRoleList}
            />
            
            {roleModalView &&<AddRoleModal 
                mode={roleModalView}
                roleInfo={selectedRole}
                show
                onClose={() => {
                    setRoleModalView('');  
                }}
                onSubmit={onAddRole}
            />
            }
            <ModalAtom 
                title={t('delete-role')} 
                body={<p>{t('delete-role-warning')}</p>}
                saveText="delete"
                show={showDeleteModal} 
                handleClose={() => setShowdeleteModal(false) }
                handleSubmit={onDeleteRole }
            />
        </>
    );
}

export default RoleSettingPage;
